<fgb-page-header [backButtonLink]="'/games'" [pageTitle]="'games.page.predictor'" [showFooter]="false" [showBanner]="false"/>
<!--Banner-->
<fgb-portal-games-banner [isPredictorPage]="true"></fgb-portal-games-banner>
<!--Nav-->
<div class="mb-3 container">
  <fgb-game-nav
    [tabs]="['games.tab.live.upcoming' | translate, 'games.tab.results' | translate]"
    (tabSelectionChange)="onTabChange($event)"
  />
</div>

<div class="container">
  <ng-container *ngIf="gamesGroup$ | async as gamesGroup; else shimmerEffect">
    <fgbcl-games-group-list
      [gamesGroup]="gamesGroup"
      [groupType]="groupType"
      [filters]="filters"
      [sort]="sort"
      [default]="false"
    ></fgbcl-games-group-list>
    <!--No Games Placeholder-->
    <!-- <ng-template #noGame>
      <div class="d-flex align-items-center justify-content-center no-game-card">
        {{ 'fgbcl.game.no.predictor.game.available.text' | translate }}
      </div>
    </ng-template> -->
  </ng-container>
  <!--Loading Placeholder-->
  <ng-template #shimmerEffect>
    <div class="row">
      <div class="col-12 col-lg-4 mb-4" *ngFor="let i of [1, 2, 3]">
        <div class="card border-grey" aria-hidden="true">
          <svg
            class="bd-placeholder-img card-img-top"
            width="100%"
            height="130"
            xmlns="http://www.w3.org/2000/svg"
            role="img"
            aria-label="Placeholder"
            preserveAspectRatio="xMidYMid slice"
            focusable="false"
          >
            <rect width="100%" height="100%" fill="#c8102e"></rect>
          </svg>
          <div class="card-body d-flex flex-column justify-content-between bg-secondary">
            <div>
              <h6 class="card-title placeholder-glow">
                <span class="placeholder col-6"></span>
              </h6>
              <p class="card-text placeholder-glow">
                <span class="placeholder col-7"></span>
              </p>
            </div>
            <button class="btn btn-primary disabled placeholder w-100"></button>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
</div>
